import { ISusuarioList, UsuarioList } from './UsuarioList';

export interface Usuario {
  id: string;
  nome: string | null;
  cpf?: string | null;
  login: string;
  tipo: 'ADMINISTADOR' | 'USUARIO' | null;
  administradorSite?: boolean;
  administradorOuvidoria?: boolean;
  dataHoraCriacao?: Date | string;
  telefone?: string | null;
  ativo?: boolean;
}

export const ISusuario: Usuario = {
  id: '',
  nome: '',
  login: '',
  cpf: '',
  administradorOuvidoria: false,
  administradorSite: false,
  tipo: null,
  dataHoraCriacao: '',
  telefone: '',
  ativo: false,
};

export interface UsuarioDTO {
  id: string;
  nome: string | null;
  cpf?: string | null;
  login: string;
  tipo: 'ADMINISTADOR' | 'USUARIO' | null;
  administradorSite?: boolean;
  administradorOuvidoria?: boolean;
  telefone?: string | null;
  senha?: string;
  ativo?: boolean;
}
export const ISusuarioDTO: UsuarioDTO = {
  id: '',
  nome: '',
  login: '',
  cpf: '',
  administradorOuvidoria: false,
  administradorSite: false,
  tipo: null,
  telefone: '',
  senha:'',
  ativo:false,
};
